import { useEffect, useState } from "react";
import { listPurchases, retryPurchase } from "../utils/purchaseHelpers";

export default function PurchaseHistory({ userId, APIKey, onRefresh }) {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");
  const load = async () => {
    try { setOrders(await listPurchases(APIKey)); setError(""); }
    catch { setError("Unable to load purchases. Please try again."); }
  };
  useEffect(() => { if (userId) load(); }, [userId, APIKey]); // eslint-disable-line react-hooks/exhaustive-deps
  const retry = async orderId => {
    setBusy(orderId);
    try { await retryPurchase(orderId, userId, APIKey); await load(); await onRefresh?.(); }
    catch { setError("Unable to resume purchase. Keep the order ID and contact support."); }
    finally { setBusy(""); }
  };
  return <section className="mx-4 my-6 p-4 rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
    <div className="flex justify-between"><h2 className="font-bold">Purchases</h2><button onClick={load} className="text-blue-500">Refresh</button></div>
    <p className="text-sm my-2">Pending payment? Resume the same order. Do not pay again. Contact @biscopesupport_bot with your order ID if needed.</p>
    {error && <p role="alert" className="text-red-500">{error}</p>}
    {!orders.length && <p className="text-sm text-slate-500">No recent orders.</p>}
    {orders.map(order => <div key={order.orderId} className="py-3 border-t border-slate-200 dark:border-slate-700">
      <p>{order.kind} · {order.method} · {order.state}</p>
      <p className="text-xs break-all">Order: {order.orderId}</p>
      {order.error && <p className="text-sm">{order.error}</p>}
      {['pending', 'verifying', 'paid'].includes(order.state) && <button disabled={busy === order.orderId} onClick={() => retry(order.orderId)} className="text-blue-500 py-2">{busy === order.orderId ? 'Checking…' : 'Resume / check payment'}</button>}
    </div>)}
  </section>;
}
